import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "../rootStore";

export const selectCurrentExamGroup = ({ examGroup }: RootState) => examGroup.currentExamGroup;

export const selectLoading = ({ examGroup }: RootState) => examGroup.loading;

export const selectCurrentExamGroupRightKnee = ({ examGroup }: RootState) => examGroup.currentExamGroupRightKnee;
export const selectCurrentExamGroupLeftKnee = ({ examGroup }: RootState) => examGroup.currentExamGroupLeftKnee;
export const selectCurrentExamGroupDoubleKnee = ({ examGroup }: RootState) => examGroup.currentExamGroupDoubleKnee;